import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

import { RouteParam, ServiceBase } from '../service-base';
import { LegalDocument } from 'src/app/@shared/models/legal/legal-document.model';
import { LegalDocumentTypeEnum } from 'src/app/@shared/enums/legal-document-type.enum';
import { Logger } from '../logger/logger.service';

const LOGGER = new Logger('LegalDocumentService');

const CLASS_NAME = 'LegalDocument';
const ENDPOINT = `/legal-documents/`;
const ROUTES: RouteParam[] = [
    { key: 'latest', path: '{type}/latest/' },
];

@Injectable({
    providedIn: 'root'
})
export class LegalDocumentService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addRoutes(ROUTES);
    }

    public getLatest$(type: LegalDocumentTypeEnum): Observable<LegalDocument | null> {
        const url = this.routes.latest.replace('{type}', type);
        this._reading$.next(true);
        return this.httpClient.get(url).pipe(
            finalize(() => this._reading$.next(false)),
            map((data: any) => new LegalDocument(data)),
            catchError((error: any) => {
                LOGGER.error('Erreur lors du chargement du document légal', error);
                return of(null);
            })
        );
    }
}
